import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { createMaterial } from "#modules/materials/infra/createMaterial.api";
import { customMaterialsQuery } from "#modules/materials/infra/customMaterials.query";
import { materialsQuery } from "#modules/materials/infra/materials.query";

export const useCreateMaterial = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: createMaterial,
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries(materialsQuery()),
        queryClient.invalidateQueries(customMaterialsQuery()),
      ]),
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { createMaterial: mutate, ...rest };
};
